import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_RecordOfBilledServices = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_RecordOfBilledServices' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <center> <h3> <b> RECORD OF BILLED SERVICES </b> </h3> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> LAST NAME: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> FIRST NAME: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtLastName' name='txtLastName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtFirstName' name='txtFirstName' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> DOB: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> MEDICAID NUMBER: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtDob' name='txtDob' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMedicaidNumber' name='txtMedicaidNumber' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'> ADDRESS: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> CITY: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> ZIP: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtAddress' name='txtAddress' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCity' name='txtCity' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtZip' name='txtZip' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'> PRIMARY DIAGNOSIS: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> ICD-10 CODE: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtPrimaryDiagnosis' name='txtPrimaryDiagnosis' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtIcdCode' name='txtIcdCode' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'> CASE MANAGER NPI NUMBER: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> AUTHORIZATION NUMBER: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtCaseManager' name='txtCaseManager' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtAuthorization' name='txtAuthorization' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> NUMBER OF AUTHORIZED SERVICES: </b>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> COMPREHENSIVE </span> </td>
                        <td className='w-250'> <span className='eleHeader'> FACE-TO-FACE FOLLOW-UP </span> </td>
                        <td className='w-250'> <span className='eleHeader'> TELEPHONE FOLLOW-UP </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtComprehensive' name='txtComprehensive' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtFaceToFace' name='txtFaceToFace' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtTelephoneFollowUp' name='txtTelephoneFollowUp' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> EFFECTIVE DATES: </b>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> FROM: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> TO: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtEffectiveDateFrom' name='txtEffectiveDateFrom' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtEffectiveDateTo' name='txtEffectiveDateTo' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <center> <h4> <b> BILLED SERVICES </b> </h4> </center>
                </p>
                <p className='small w-750'> <center> (ALL SERVICES USE PROCEDURE CODE G9012) </center>
                </p>

                <table>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'> Service </span> </td>
                        <td className='w-300'> <span className='eleHeader'> Required Modifiers </span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Comprehensive visit (in-person) </td>
                        <td className='w-300'> U2 and U5 </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Comprehensive visit (synchronous audiovisual) </td>
                        <td className='w-300'> U2, U5, and 95 </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Follow-up visit (in-person) </td>
                        <td className='w-300'> U5 and TS </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Follow-up visit (synchronous audiovisual) </td>
                        <td className='w-300'> U5, TS, and 95 </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Follow-up visit telephone (audio-only) </td>
                        <td className='w-300'> TS and 93 </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'> DOS </span> </td>
                        <td className='w-100'> <span className='eleHeader'> POS </span> </td>
                        <td className='w-250'> <span className='eleHeader'> MODIFIERS </span> </td>
                        <td className='w-300'> <span className='eleHeader'> CASE MANAGER'S SIGNATURE </span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtDos_1' name='txtDos_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPos_1' name='txtPos_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtModifiers_1' name='txtModifiers_1' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtCaseManager_1' name='txtCaseManager_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtDos_2' name='txtDos_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPos_2' name='txtPos_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtModifiers_2' name='txtModifiers_2' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtCaseManager_2' name='txtCaseManager_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtDos_3' name='txtDos_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPos_3' name='txtPos_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtModifiers_3' name='txtModifiers_3' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtCaseManager_3' name='txtCaseManager_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtDos_4' name='txtDos_4' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPos_4' name='txtPos_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtModifiers_4' name='txtModifiers_4' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtCaseManager_4' name='txtCaseManager_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtDos_5' name='txtDos_5' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPos_5' name='txtPos_5' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtModifiers_5' name='txtModifiers_5' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtCaseManager_5' name='txtCaseManager_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtDos_6' name='txtDos_6' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPos_6' name='txtPos_6' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtModifiers_6' name='txtModifiers_6' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtCaseManager_6' name='txtCaseManager_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtDos_7' name='txtDos_7' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPos_7' name='txtPos_7' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtModifiers_7' name='txtModifiers_7' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtCaseManager_7' name='txtCaseManager_7' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtDos_8' name='txtDos_8' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtPos_8' name='txtPos_8' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtModifiers_8' name='txtModifiers_8' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtCaseManager_8' name='txtCaseManager_8' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <center> <b> CLAIM STATUS </b> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> DATE FILED </span> </td>
                        <td className='w-250'> <span className='eleHeader'> PAID? Y or N </span> </td>
                        <td className='w-250'> <span className='eleHeader'> R&S # </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateFiled_1' name='txtDateFiled_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPaid_1' name='txtPaid_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRs_1' name='txtRs_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateFiled_2' name='txtDateFiled_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPaid_2' name='txtPaid_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRs_2' name='txtRs_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateFiled_3' name='txtDateFiled_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPaid_3' name='txtPaid_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRs_3' name='txtRs_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateFiled_4' name='txtDateFiled_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPaid_4' name='txtPaid_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRs_4' name='txtRs_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateFiled_5' name='txtDateFiled_5' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPaid_5' name='txtPaid_5' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRs_5' name='txtRs_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateFiled_6' name='txtDateFiled_6' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPaid_6' name='txtPaid_6' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRs_6' name='txtRs_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateFiled_7' name='txtDateFiled_7' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPaid_7' name='txtPaid_7' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRs_7' name='txtRs_7' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateFiled_8' name='txtDateFiled_8' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPaid_8' name='txtPaid_8' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRs_8' name='txtRs_8' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-200'> <b> DOS = DATE OF SERVICE </b> </td>
                        <td className='w-200'> <b> POS = PLACE OF SERVICE </b> </td>
                        <td className='w-350'> <b> R&S = REMITTANCE AND STATUS REPORT </b> </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}











